import React, { useEffect } from 'react';
import { Hero } from './components/Hero';
import { TestimonialsSection } from './components/TestimonialsSection';
import { ProblemSection } from './components/ProblemSection';
import { VolumesSection } from './components/VolumesSection';
import { BonusesSection } from './components/BonusesSection';
import { OfferSection } from './components/OfferSection';
import { DigitalSection } from './components/DigitalSection';
import { GuaranteeSection } from './components/GuaranteeSection';
import { FaqSection } from './components/FaqSection';
import { FinalCtaSection } from './components/FinalCtaSection';
import { Footer } from './components/Footer';
import { StickyCta } from './components/StickyCta';
import { useMetaPixel } from './hooks/useMetaPixel';
interface AppProps {
  /** Page palette: bright "court" look or the dark teal "midnight" arena look. */
  theme?: 'court' | 'midnight';
}
const THEME_COLORS = {
  court: '#f6f9f8',
  midnight: '#061a1d'
};
export function App({
  theme = 'court'
}: AppProps) {
  useMetaPixel();
  useEffect(() => {
    const root = document.documentElement;
    if (theme === 'midnight') root.dataset.theme = 'midnight';else delete root.dataset.theme;
    document.querySelector<HTMLMetaElement>('meta[name="theme-color"]')?.setAttribute('content', THEME_COLORS[theme]);
  }, [theme]);
  return <div className="w-full bg-ink font-sans text-fg" data-id="element-0" data-mp="56l3b4umzkw">
      <Hero data-id="element-1" data-mp="2zlv7cvunj3vl" />
      <main data-id="element-2" data-mp="2zm4xqkjlzd1t">
        <TestimonialsSection data-id="element-3" data-mp="2zmo3z3zwcd00" />
        <ProblemSection data-id="element-4" data-mp="2zng32ospcsv1" />
        <VolumesSection data-id="element-5" data-mp="33m5b01uz1i7a" />
        <BonusesSection data-id="element-6" data-mp="33nq9g2keplaf" />
        <OfferSection data-id="element-7" data-mp="33mykvbp88ntn" />
        <DigitalSection data-id="element-8" data-mp="38lromcepp0gm" />
        <GuaranteeSection data-id="element-9" data-mp="38l8hlqqlnwhd" />
        <FaqSection data-id="element-10" data-mp="38l06o4e1f18t" />
        <FinalCtaSection data-id="element-11" data-mp="38kgnylgkc8tq" />
      </main>
      <Footer data-id="element-12" data-mp="3dkl0y1i9ilf7" />
      <StickyCta data-id="element-13" data-mp="3dl4kfmnk9hvc" />
    </div>;
}